import Typography from '@mui/material/Typography'
import { makeStyles } from '@mui/styles'
import withStyles from '@mui/styles/withStyles'
import { isEmpty } from 'lodash'
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { userService } from '../../lib/services'

const styles = ({ palette, spacing, breakpoints, border }) => ({
    wrapper: {
        width: 500,
        padding: spacing(1),
        display: 'flex',
        justifyContent: 'space-between',
        border: border.default,
        borderRadius: border.radius.round,
        [breakpoints.down('md')]: {
            marginLeft: 'auto',
            marginRight: 'auto',
            textAlign: 'center',
        },
    },
    item: {
        width: 100,
        borderRadius: '8px',
        padding: spacing(1),
        margin: spacing(0.5),
        backgroundColor: palette.primary.main,
        color: palette.getContrastText(palette.primary.main),
    },
    box: {
        display: 'flex',
        gap: spacing(0.5),
        width: 'fit-content',
        justifyContent: 'flex-start',
    },
    header: {
        color: 'white',
    },
})

interface ContextDetailsProps {
    context: string
}

const ContextDetails = forwardRef(({ context }: ContextDetailsProps, ref) => {
    const [summaryObj, setSummaryObj] = useState({
        userCount: 0,
        superUserCount: 0,
        adminCount: 0,
        totalUsers: 0,
    })

    const classes = makeStyles(styles)()
    useEffect(() => {
        getUsersSummary()
    }, [])

    useImperativeHandle(ref, () => ({
        refresh,
    }))

    const refresh = () => {
        getUsersSummary()
    }

    const getUsersSummary = async () => {
        const res = await userService.getUsersSummary(context)
        if (res?.totalUsersCount && !isEmpty(res?.usersByPermission)) {
            const { user, admin, superUser, owner } = res.usersByPermission
            setSummaryObj(s => ({
                ...s,
                totalUsers: res.totalUsersCount - owner ?? 0,
                superUserCount: superUser ?? 0,
                userCount: user ?? 0,
                adminCount: admin ?? 0,
            }))
        }
    }
    return (
        <div className={classes.box}>
            <div className={classes.item}>
                <Typography variant="caption">Total Users</Typography>
                <Typography variant="h6" className={classes.header}>
                    {summaryObj.totalUsers}
                </Typography>
            </div>
            <div className={classes.item}>
                <Typography variant="caption">Admins</Typography>
                <Typography variant="h6" className={classes.header}>
                    {summaryObj.adminCount}
                </Typography>
            </div>
            <div className={classes.item}>
                <Typography variant="caption">Super Users</Typography>
                <Typography variant="h6" className={classes.header}>
                    {summaryObj.superUserCount}
                </Typography>
            </div>
            <div className={classes.item}>
                <Typography variant="caption">Users</Typography>
                <Typography variant="h6" className={classes.header}>
                    {summaryObj.userCount}
                </Typography>
            </div>
        </div>
    )
})

export default withStyles(styles)(ContextDetails)
